// Maps BE `state` values on /parameters/live to chip display config.
// Alert-family states (just_off, predictive, ongoing) all render as the Alert chip.
// Add new states here — no other file needs changing.

export const PARAM_STATUS_META = {
  ok: {
    label: 'OK',
    icon: 'check',
    bg: 'rgba(16,185,129,0.08)',
    border: 'rgba(16,185,129,0.2)',
    color: '#059669',
  },
  just_off: {
    label: 'Alert',
    icon: 'warning',
    bg: 'rgba(186,26,26,0.06)',
    border: 'rgba(186,26,26,0.18)',
    color: '#b91c1c',
  },
  predictive: {
    label: 'Alert',
    icon: 'warning',
    bg: 'rgba(186,26,26,0.06)',
    border: 'rgba(186,26,26,0.18)',
    color: '#b91c1c',
  },
  ongoing: {
    label: 'Alert',
    icon: 'warning',
    bg: 'rgba(186,26,26,0.06)',
    border: 'rgba(186,26,26,0.18)',
    color: '#b91c1c',
  },
  stale: {
    label: 'Stale',
    icon: 'sensors_off',
    bg: 'rgba(180,120,0,0.07)',
    border: 'rgba(180,120,0,0.22)',
    color: '#b45309',
  },
};

// Fallback chip when state is missing — FE computes ok/alert from optimumLow/High
export const PARAM_STATUS_FALLBACK_OK = PARAM_STATUS_META.ok;
export const PARAM_STATUS_FALLBACK_ALERT = PARAM_STATUS_META.just_off;
